/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
const Faq = () => {

    const { t } = useTranslation();
    const { ApiBaseUrl } = useContext(MyContext);

    const [faqList, setFaqList] = useState([]);
    const [expandedIndex, setExpandedIndex] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`${ApiBaseUrl}/customer/faq_list`)
            .then((res) => {
                // console.log("faq_list", res);
                setFaqList(res.data.faq_list);
                setLoading(false);
            })
            .catch((error) => {
                console.error("faq_list", error);
            });
    }, []);

    const handleChange = (index) => {
        const Index = expandedIndex === index ? "" : index;
        setExpandedIndex(Index);
    };

    return (
        <div className='w-full width-container content-wrapper'>
            {loading
                ? <Loading CustomeStyle="h-[100vh] -mt-[140px] w-full flex items-center justify-center bg-white" index={0} />
                : <div className="mt-[25px]">
                    {faqList.map((item, index) => {
                        return (
                            <div key={index} className="mb-[8px]">
                                <Accordion style={{
                                    border: '1px solid #8080803b', borderRadius: "20px", padding: "10px 0"
                                }} expanded={expandedIndex === index} onChange={() => handleChange(index)}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls={`panel${index}-content`}
                                        id={`panel${index}-header`}
                                    >
                                        <Typography className='max-_430_:text-[14px]' component="span">{item.title}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className='max-_430_:text-[14px]'>{item.description}</AccordionDetails>
                                </Accordion>
                            </div>
                        );
                    })}
                </div>}
        </div>
    )
}

export default Faq
/* jshint ignore:end */